export default {
  audioPlayer: 'cursor-pointer bg-[#E7EEF6] px-3 py-2 rounded-full w-fit h-fit flex gap-[12px] items-center border border-[#CEDCEC]',
  audioTitle: 'font-interMedium pr-[20px] sm:max-w-[290px] max-w-[220px] overflow-hidden',
};
